import axios, { AxiosError } from "axios";
import { config } from "@/lib/config";
import { authService } from "@/services/AuthService";

const API_BASE_URL = config.VITE_API_URL;

const axiosInstance = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  withCredentials: true,
});

// Add auth token interceptor
axiosInstance.interceptors.request.use(async (config) => {
  const token = await authService.getAccessToken();
  if (token && !config.url?.startsWith("http")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error instanceof AxiosError && error.response?.status === 401) {
      // Handle 401 unauthorized - redirect to home which will trigger login via ProtectedRoute
      console.error("Unauthorized - redirecting to home");
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
